import React from 'react'
import styled from 'styled-components'
import {injectIntl} from 'react-intl'
import image from 'images/image-home-02.png'
import image_retina from 'images/image-home-02@2x.png'

const Container = styled.div`
    display: flex;
	align-items: center;
    flex-direction: column;
    width: 70%;
    margin: 50px auto;
`

const Text = styled.div`
	margin-top: 20px;
	font-weight: 700;
	text-align: center;
    font-size: 16px;
`

const Image = styled.img`
	max-height: 400px;
`

export default injectIntl(({intl}) =>
	<Container>
		<Image src={image} srcSet={`${image_retina} 2x`} alt="" />
		<Text>{intl.formatMessage({id: "app.restrictive_filters"})}</Text>
	</Container>
)
